'use client'

// React Imports
import { useEffect } from 'react'

// Type Imports
import type { Mode } from '@core/types'

// Component Imports
import HeroSection from './HeroSection'
import TrustSection from './TrustSection'
import Advantages from './Advantages'
import Benefits from './Benefits'
import WhyChoose from './WhyChoose'
import AllInOne from './AllInOne'
import CallToAction from './CallToAction'
import Rates from './rates/Rates'
import ContactUs from './ContactUs'
import dynamic from 'next/dynamic'
import { useSettings } from '@core/hooks/useSettings'

// Dynamically import non-critical components
const CustomerReviews = dynamic(() => import('./CustomerReviews'), {
  loading: () => <p>Loading customer reviews...</p>,
  ssr: false
})

const FAQSection = dynamic(() => import('./faq/FAQSection'), {
  loading: () => <p>Loading FAQ...</p>,
  ssr: false
})

const LandingPageWrapper = ({ mode, dictionary }) => {
  // Hooks
  const { updatePageSettings } = useSettings()

  // For Page specific settings
  useEffect(() => {
    return updatePageSettings({
      skin: 'default'
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <HeroSection />
      <TrustSection />
      <Advantages />
      <Benefits />
      <WhyChoose />
      <AllInOne />
      <CallToAction />
      <Rates mode={mode} />
      <CustomerReviews />
      <FAQSection />
      <ContactUs />
    </>
  )
}

export default LandingPageWrapper
